// extracted by mini-css-extract-plugin
export var aggregationCell = "_2w-f";
export var aggregationRow = "_2w-e";
export var borderlessSpinnerContainer = "_2w-2";
export var closeIcon = "_2w-7";
export var expandIcon = "_2w-8";
export var expanded = "_2w-9";
export var filterDropdown = "_2w-a";
export var filterDropdownDivider = "_2w-5";
export var filterDropdownHeader = "_2w-d";
export var filterDropdownItem = "_2w-c";
export var filterDropdownModal = "_2w-b _2w-a";
export var filterItem = "_2w-4";
export var normalCellWithAdjustableBorder = "_2w-6";
export var pinButtonContainer = "_2w-g";
export var pinIcon = "_2w-h";
export var pinIconActive = "_2w-i";
export var spinner = "_2w-0";
export var spinnerContainer = "_2w-1";
export var tableContainer = "_2w-3";
export var viewButtonContainer = "_2w-j";